<template>
  <div class="settings-main">
    <div class="title-box">
      <div class="flex-start">
        <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
          <IconArrowBack/>
          {{ backButtonLabel }}
        </button>

        <h2 class="title">{{ $t('createClinic.configuration') }}</h2>
      </div>

      <div class="flex-end" id="btnDeletePatientShowSlot"></div>
    </div>

    <BaseTab :tabs="tabs" :initialtab="tabActive" :key="tabActive" @tab-activated="switchTab">
      <template v-slot:tab-head-users>
        {{ $t('menu.users') }}
      </template>
      <template v-slot:users>
        <UserList v-if="tabActive === 'users'" />
      </template>

      <template v-slot:tab-head-devices>
        {{ $t('menu.devices') }}
      </template>
      <template v-slot:devices>
        <DeviceList v-if="tabActive === 'devices'"/>
      </template>

      <template v-slot:tab-head-audit>
        {{ $t('menu.audit') }}
      </template>
      <template v-slot:audit>
        <AuditList v-if="tabActive === 'audit' && isDataReady"/>
      </template>

      <template v-slot:tab-head-clinics>
        {{ $t('menu.clinics') }}
      </template>
      <template v-slot:clinics>
        <ClinicList v-if="tabActive === 'clinics' && isDataReady"/>
      </template>

      <template v-slot:tab-head-clinics-archived>
        {{ $t('menu.clinicsArchived') }}
      </template>
      <template v-slot:clinics-archived>
        <ClinicArchivedList v-if="tabActive === 'clinics-archived' && isDataReady"/>
      </template>

      <template v-slot:tab-head-edi>
        {{ $t('menu.edi') }}
      </template>
      <template v-slot:edi>
        <EdiSettings v-if="tabActive === 'edi' && isDataReady"/>
      </template>

      <template v-slot:pagination>
        <div class="slot-pagination" id="settingsPagination"></div>
      </template>
      <template v-slot:paginationMobile>
        <div class="slot-pagination" id="settingsPaginationMobile"></div>
      </template>
    </BaseTab>

    <div class="action-bar" @wheel.prevent>
      <div id="settingsActionBar"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.settings-main {
  .title-box {
    margin:                          0;

    .flex-start {
      gap:                           15px;
    }

    .btn-back {
      margin:                        0;
    }
  }
}

.action-bar {
  position:                          sticky;
  bottom:                            0;
  z-index:                           2;
  background:                        var(--Shades-BG);
}

.slot-pagination {
  display:                           flex;
  margin-left:                       auto;
}

#settingsPaginationMobile {
  justify-content:                   center;
}

@media (max-width: 991px) {
  .settings-main {
    .title-box .btn-outline-secondary span {
      display:                       none;
    }

    .title-box {
      padding:                       10px;

      .title {
        font-size:                   18px !important;
      }

      .btn-outline-secondary {
        padding:                     11.5px 15px;
        svg {
          margin:                    0;
        }
      }

      .btn-back,
      .btn-outline-secondary {
        height:                      35px;
        margin:                      0 !important;
      }
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import ClinicList from '../clinic/clinic-list.vue'
import ClinicArchivedList from '../clinic/clinic-archived-list.vue'
import UserList from '../user/user-list.vue'
import DeviceList from '../device/device-list.vue'
import AuditList from '../audit/audit-list.vue'
import EdiSettings from '../edi/edi-settings.vue'

export default {
  name: 'Settings',
  components: {
    ClinicList,
    ClinicArchivedList,
    UserList,
    DeviceList,
    AuditList,
    EdiSettings
  },
  data: () => ({
    active: null,
    allowSynchronization: true,
    isSpecialist: null,
    isPowerfull: null,
    session: null,
    isDataReady: false,
    tabActive: null,
    tabs: [],
    hasClaimFeature: false,
    hasClinicArchivingFeature: false
  }),
  computed: {
    backButtonLabel() {
      return this.$utils.getSectionEntryRouteTitle(this) || this.$i18n.t('goBack')
    },
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo

    this.isSpecialist = this.session.isSpecialist
    this.isPowerfull = this.session.isPowerfull
    this.hasClaimFeature = this.session.features.includes('claims')
    this.hasClinicArchivingFeature = this.$utils.isFeatureEnabled('clinicArchiving')

    this.tabs = this.isPowerfull
      ? [
          'users',
          'devices',
          'audit',
          'clinics',
          this.hasClinicArchivingFeature && 'clinics-archived',
          this.hasClaimFeature && 'edi',
        ].filter(Boolean)
      : ['clinics']

    this.switchTab(this.$route.query.tab || this.tabs[0])

    this.allowSynchronization = this.session.currentClinic.synchronizePatientData ?? true

    this.isDataReady = true
  },
  methods: {
    switchTab(tab) {
      this.tabActive = tab;
    },
    goBack() {
      // this.$router.push({name: 'patient-list'})
      this.$router.go(-1)
    },
  }
}
</script>
